<template>
  <div class="share-item">
    <div class="social">
      <p>Partager sur</p>
      <SocialShare
        network="facebook"
        :url="shareURL"
        :title="share.title"
        :description="share.description"
        @close="shareContent"
      >
        <div class="fb icon">
          <img
            src="~/assets/icons/facebook-f.svg"
            alt="facebook"
          />
        </div>
      </SocialShare>
      <SocialShare
        network="twitter"
        :url="shareURL"
        :title="share.title"
        @close="shareContent"
      >
        <div class="twitter icon">
          <img
            src="~/assets/icons/twitter.svg"
            alt="facebook"
          />
        </div>
      </SocialShare>
    </div>
    <p
      class="copy"
      @click="copyRoute"
    >
      <template v-if="!copied"> Copier le lien </template>
      <template v-else>
        Lien copié
        <img
          src="~/assets/icons/check.svg"
          alt="check"
          class="check"
        />
      </template>
    </p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  share: {
    title?: string
    description?: string
    slug?: string
    slugType?: string
  }
}>()

const { authenticated } = useAuthenticated()
const socialStore = useSocialStore()
const shareContent = () => {
  if (authenticated.value) {
    return socialStore.shareContent()
  }
}

const route = useRoute()
const shareURL = computed(() => {
  return window.location.origin + route.fullPath
})

const copied = ref(false)
const clipboard = useClipboard()
const copyRoute = async () => {
  try {
    await clipboard.copy(shareURL.value)
    copied.value = true
  } catch (err) {
    console.error(err)
  }
}
</script>

<style lang="scss" scoped>
.share-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 6rem;
  padding: 0 2rem;
  color: $white;
  background: $blue;

  @media (min-width: 700px) {
    padding: 0 3rem;
  }

  .social {
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 2rem;
    border-right: 1px solid rgba(#fff, 0.16);

    @media (min-width: 700px) {
      padding-right: 3rem;
    }
  }

  .copy {
    cursor: pointer;

    img {
      width: 1.1rem;
      height: 1.1rem;
      margin-left: 0.3rem;
    }
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.6rem;
    height: 2.6rem;
    border-radius: 1.3rem;
    cursor: pointer;

    img {
      width: 1.05rem;
      height: 1.05rem;
      object-fit: contain;
    }

    &.fb {
      margin-left: 1rem;
      background: #3d5a96;

      @media (min-width: 700px) {
        margin-left: 3rem;
      }
    }

    &.twitter {
      margin-left: 1rem;
      background: #2aa3ef;
    }
  }
}
</style>
